var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7601_73648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0605 3.9668C14.8178 3.9668 14.6211 4.16355 14.6211 4.40625C14.6211 5.94091 13.3725 7.18945 11.8379 7.18945C11.3963 7.18945 10.9704 7.0873 10.5872 6.8942L10.9029 6.81979C11.1391 6.76412 11.2855 6.52746 11.2298 6.29124C11.1741 6.05502 10.9375 5.90865 10.7012 5.96432L9.45827 6.25726C9.25984 6.30401 9.11963 6.48111 9.11963 6.68499V7.92797C9.11963 8.17066 9.31639 8.36742 9.55908 8.36742C9.80178 8.36742 9.99854 8.17066 9.99854 7.92797V7.57441C10.5512 7.89648 11.1812 8.06836 11.8379 8.06836C13.8571 8.06836 15.5 6.42554 15.5 4.40625C15.5 4.16355 15.3032 3.9668 15.0605 3.9668Z",
    fill: "#F9C416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6152 4.84594C8.8579 4.84594 9.05466 4.64918 9.05466 4.40648C9.05466 2.87183 10.3032 1.62328 11.8379 1.62328C12.2793 1.62328 12.7048 1.72576 13.0879 1.91877L12.7728 1.99307C12.5366 2.04876 12.3903 2.28542 12.4459 2.52164C12.5016 2.75786 12.7383 2.9042 12.9745 2.84851L14.2175 2.55545C14.4159 2.50866 14.5561 2.33159 14.5561 2.12771V0.884766C14.5561 0.64207 14.3594 0.445312 14.1167 0.445312C13.874 0.445312 13.6772 0.64207 13.6772 0.884766V1.23832C13.1246 0.91626 12.4945 0.744375 11.8379 0.744375C9.8186 0.744375 8.17578 2.3872 8.17578 4.40648C8.17575 4.64918 8.37251 4.84594 8.6152 4.84594Z",
    fill: "#F9C416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.844 10.1088C11.3292 9.59395 10.4944 9.59395 9.97957 10.1088L9.66858 10.4198L12.8796 13.6308L13.1906 13.3198C13.7054 12.8049 13.7054 11.9702 13.1906 11.4553L11.844 10.1088Z",
    fill: "#F9C416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87648 11.2124C8.57627 11.5126 8.1048 11.556 7.75438 11.3163C6.51562 10.469 5.47663 9.43004 4.62934 8.19131C4.38966 7.84089 4.43305 7.36941 4.73325 7.06921L4.90394 6.89853L1.69297 3.6875L1.14184 4.23863C0.515469 4.865 0.328496 5.80605 0.665469 6.63608C1.49264 8.67351 2.63996 10.4345 4.07554 11.8701C4.07563 11.8702 4.07545 11.87 4.07557 11.8701C5.51108 13.3056 7.27224 14.453 9.30954 15.2802C10.1396 15.6172 11.0806 15.4302 11.707 14.8038L12.2581 14.2527L9.04716 11.0417L8.87648 11.2124Z",
    fill: "#F9C416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83644 5.96628C6.3513 5.45145 6.3513 4.61669 5.83644 4.10183L4.48989 2.75529C3.97503 2.24042 3.1403 2.24042 2.62544 2.75529L2.31445 3.06627L5.52545 6.27727L5.83644 5.96628Z",
    fill: "#F9C416"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7601_73648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.445312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeNumber);
export default __webpack_public_path__ + "static/media/change-number.18254691f78c60d523de8a89456dad71.svg";
export { ForwardRef as ReactComponent };